import { React, PropTypes, ReactHtmlParser, useState, useEffect } from '../../../../../includes'

export const AlmaviaFetch = ({item}) => {
    const [html, setHTML] = useState();

    useEffect(() => {
        async function createMarkup() {
            let contentId = document.getElementById(item.content_id)

            let response = await fetch(
                Routing.generate(item.route),
                {
                    method: 'POST',
                    body: JSON.stringify({'contentID': contentId.value})
                }
            )

            return await response.text();
        }

        createMarkup().then(response => {
            setHTML(response)
        })
    }, []);

    return <>
        {ReactHtmlParser(html)}
    </>
}

AlmaviaFetch.prototype = {
    contentId: PropTypes.number,
}
